export default __webpack_public_path__ + "static/media/datacakraLogoWhite.486f1880.png";